import sortPrices from './sortedprices';

// This function is used on priceType Selector for seated sections
export default (seat, prices, priceTypes) => {
  if (!seat) { return []; }

  return sortPrices(prices, priceTypes)
    .filter(price => price.priceCategory === seat.priceLevel)
    // include the pricetype object
    .map(price => ({ price, priceType: priceTypes[price.priceType] }))
    // if the clicked seat has a blocking code
    .filter(priceObj => {
      if (seat.blockingCode > 0) {
        // we check the price type's blocking codes to see if the seat's code is a match
        return priceObj.priceType.blockingCodes.indexOf(seat.blockingCode) !== -1;
      }
      else {
        //  if the seat has not blocking code we remove the price types that have blocking codes
        return priceObj.priceType.blockingCodes.length <= 0;
      }
    });
};



// WEBPACK FOOTER //
// ./frontend/react/utils/sim/prices_for_seat.js